import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { CalendlyGroupsPanel } from "@/features/supply-config/ui/calendly-panels";
import { Button } from "@/components/ui/button";

export default function TeamCalendly() {
  const navigate = useNavigate();
  return (
    <div className="py-6 space-y-4">
      <div className="px-6 flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={() => navigate("..")}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-semibold">Teams — Calendly groups</h1>
      </div>
      <CalendlyGroupsPanel
        onCreateFromGroup={(prefill) =>
          navigate("../new", { state: { prefill } })
        }
      />
    </div>
  );
}
